import React from "react";
import { useNavigate } from "react-router-dom";

const GrowthAndCareersSection = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14 lg:py-16">
        {/* ============== Section 1 (Image left, Content right) ============== */}
        <div className="grid items-center gap-8 lg:gap-12 lg:grid-cols-2">
          {/* Image */}
          <div className="order-1">
            <div className="overflow-hidden rounded-2xl bg-slate-100 ring-1 ring-black/5">
              <img
                src="/assets/careers-hero.png"
                alt="Professional overlooking city skyline"
                className="w-full object-cover aspect-[16/10] sm:aspect-[16/9]"
                loading="lazy"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-2 text-center lg:text-left">
            <p
              className="
                text-slate-700
                text-[clamp(0.95rem,1.15vw,1.05rem)]
                leading-7 sm:leading-8
                max-w-xl mx-auto lg:mx-0
              "
            >
              DTA provides exciting career opportunities for professionals who
              thrive in collaborative, international environments. We foster a
              culture where experienced team members actively mentor others,
              while encouraging everyone to take responsibility for both local
              and global initiatives. Together, we promote learning, ownership,
              and growth across borders.
            </p>

            <div className="mt-6 flex justify-center lg:justify-start">
              <div
                onClick={() => navigate("/career")}
                className="
                  cursor-pointer
                  inline-flex items-center justify-center
                  rounded-md bg-[#0b4f6c] text-white
                  px-6 py-3
                  text-sm font-semibold
                  shadow-sm
                  transition
                  hover:bg-[#083f56]
                  focus:outline-none focus:ring-2 focus:ring-[#0b4f6c]/40
                  focus:ring-offset-2
                "
              >
                Join the DTA team
              </div>
            </div>
          </div>
        </div>

        {/* Spacer between the two blocks */}
        <div className="h-10 sm:h-14 lg:h-20" />

        {/* ============== Section 2 (Content left, Image right) ============== */}
        <div className="grid items-center gap-8 lg:gap-12 lg:grid-cols-2">
          {/* Content */}
          <div className="order-2 lg:order-1 text-center lg:text-left">
            <h2
              className="
                font-bold tracking-tight text-[#0b4f6c]
                text-[clamp(1.35rem,2.8vw,2rem)]
                leading-[1.15]
              "
            >
              Let’s Grow Your Business Together
            </h2>

            <p
              className="
                mt-4
                text-slate-600
                text-[clamp(0.95rem,1.15vw,1.05rem)]
                leading-7 sm:leading-8
                max-w-xl mx-auto lg:mx-0
              "
            >
              At Digital Transformation Associates, we deliver customized
              digital marketing, web design, and software development solutions
              that strengthen your online presence, enhance engagement, and
              improve operational efficiency—helping your business grow
              sustainably in a competitive environment.
            </p>

            <div className="mt-6 flex justify-center lg:justify-start">
              <div
                onClick={() => navigate("/contact")}
                className="
                  inline-flex items-center justify-center
                  rounded-md bg-[#0b4f6c] text-white
                  px-6 py-3
                  text-sm font-semibold
                  shadow-sm
                  transition
                  hover:bg-[#083f56]
                  focus:outline-none focus:ring-2 focus:ring-[#0b4f6c]/40
                  focus:ring-offset-2
                "
              >
                Contact Us
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2">
            <div className="overflow-hidden rounded-2xl bg-slate-100 ring-1 ring-black/5">
              <img
                src="/assets/growth-handshake.webp"
                alt="Business handshake meeting"
                className="w-full object-cover aspect-[16/10] sm:aspect-[16/9]"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GrowthAndCareersSection;
